export enum PlanBoost {
  NENHUM = '0',
  CLINICO = '1',
  DOC = '2',
  ORTO = '3',
  PROTESE = '4',
}
